export default "__VITE_ASSET__BWfS_FWs__"